import { Fragment, useState } from "react";
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline'
import { Loader } from "../../../components/loading/Loader";
import { Bars3Icon, PlusIcon } from "@heroicons/react/20/solid";

export const AuditsList = ({ audits, setSelectedAudit }) => {

  const [open, setOpen] = useState(false);

  const handleSelectAudit = (selectedAudit) => {
    setSelectedAudit(selectedAudit);
    setOpen(false);
  };

  return (
    <>
      <button onClick={() => setOpen(true)}>
        <Bars3Icon aria-hidden="true" className="size-12" />
      </button>

      <Transition appear show={open} as={Fragment}>
        <Dialog as="div" className="relative z-10 h-full" onClose={setOpen}>
          <div className="fixed inset-0" />

          <div className="fixed inset-0 overflow-hidden text-3xl h-full">
            <div className="absolute inset-0 overflow-hidden h-full">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16 h-full">
                <Dialog.Panel
                  // transition
                  className="pointer-events-auto w-screen max-w-md transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
                >
                  <div className="relative flex h-full flex-col overflow-y-auto bg-white py-6 shadow-xl dark:bg-gray-800 dark:after:absolute dark:after:inset-y-0 dark:after:left-0 dark:after:w-px dark:after:bg-white/10">
                    <div className="px-4 sm:px-6">
                      <div className="flex items-start justify-between">
                        <Dialog.Title className="text-3xl font-semibold text-gray-900">
                          Audits list
                        </Dialog.Title>
                        <div className="ml-3 flex h-10 items-center">
                          <button
                            type="button"
                            onClick={() => setOpen(false)}
                            className="relative rounded-md text-gray-400 hover:text-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 dark:hover:text-white dark:focus-visible:outline-indigo-500"
                          >
                            <span className="absolute -inset-2.5" />
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon aria-hidden="true" className="size-9" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="relative mt-6 flex-1 px-4 sm:px-6 h-full bg-white">
                      <div className="flex flex-col gap-4 h-full bg-white">
                        {
                          audits.isLoading ? <Loader/> :
                          audits.data.sort((a, b) => b.id - a.id).map((audit, index) => {
                            const textColor = audit.status === 0 ? 'text-perception-blue' : 'text-perception-black-500';
                            const borderColor = audit.status === 0 ? 'border-perception-blue' : 'border-transparent';
                            return (
                              <div key={index} className={`p-4 bg-perception-gray-100 rounded-md flex items-center gap-4 border-2 ${textColor} ${borderColor}`}
                                onClick={() => handleSelectAudit(audit)}>
                                {
                                  audit.status === 0 ?
                                    <div className="bg-perception-blue px-2 py-1 rounded-md text-base text-white">NEW</div> :
                                    <div className="bg-perception-success-300 px-2 py-1 rounded-md text-base text-white">OK</div>
                                }
                                {audit.name}
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};